module.exports = __webpack_public_path__ + "static/media/icono_musical.84bc7fef.svg";